import { render, staticRenderFns } from "./Pfrule.vue?vue&type=template&id=17c5e4c9&scoped=true"
import script from "./Pfrule.vue?vue&type=script&lang=js"
export * from "./Pfrule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c5e4c9",
  null
  
)

export default component.exports